import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/49_card_back_pirate_ship/49_card_back_pirate_ship"
 * Contains 1 texture(s)
 */
export class CardsBacks49CardBackPirateShipAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/49_card_back_pirate_ship/49_card_back_pirate_ship';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '49_pirate_ship.png'
    ] as const;
}
